"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLottieDuration = getLottieDuration;
exports.getLottieFrameRate = getLottieFrameRate;
exports.getLottieFrameToMs = getLottieFrameToMs;
exports.getLottieMarkers = getLottieMarkers;
// frame / frameRate and multiply by 1000 to convert to milliseconds
function getLottieFrameToMs(frame, fr) {
  return frame / fr * 1000;
}
function getLottieDuration(source) {
  return getLottieFrameToMs(source.op, source.fr);
}
function getLottieFrameRate(source) {
  return source.fr;
}
function getLottieMarkers(source, opts) {
  return source.markers.reduce((prev, next) => Object.assign({}, prev, {
    [`${next.cm}`]: opts !== null && opts !== void 0 && opts.ms ? getLottieFrameToMs(next.tm, source.fr) : next.tm
  }), {});
}